import { SvyButton } from '@/components/savory/SvyButton';
import { SvyIcon } from '@/components/savory/SvyIcon';
import styled from '@emotion/styled';

export const Container = styled.div`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[4]};
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};

    h2 {
        margin-bottom: 10px;
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const AIMenuScanButton = styled(SvyButton)`
    margin-right: ${({ theme }) => theme.spacing[3]};
`;

export const ButtonIcon = styled(SvyIcon)`
    margin-right: ${({ theme }) => theme.spacing[1]};
`;
